<div class="dialog">

    <div class="dialog-header">
        <h3>{{ 'SALES_DOCUMENT|Ustawienia VAT' | translate }}</h3>
        <button
            iccIconButton
            (click)="close()"
            appearance="flat"
        >
            <icc-icon name="close"></icc-icon>
        </button>
    </div>
    <div class="dialog-body">

        <div class="flex-vertical w-100">
            <div
                class="flex-vertical w-100 mb-2 flex-left"
            >
                <icc-radio
                    id="vat-mode-default"
                    name="vat-mode"
                    [value]="'default'"
                    [checked]="mode === 'default'"
                    [disabled]="data.document?.isConfirmed || data.document?.isCanceled || data.document?.externalSource === 'ERP' || data.document?.salesDocumentTypeId === 2"
                    (valueChange)="changeOneTaxRateMode($event)"
                >
                    {{ 'SALES_DOCUMENT|Domyślny VAT sprzedaży' | translate }}
                </icc-radio>

                <icc-radio
                    id="vat-mode-global"
                    name="vat-mode"
                    [value]="'global'"
                    [checked]="mode === 'global'"
                    [disabled]="data.document?.isConfirmed || data.document?.isCanceled || data.document?.externalSource === 'ERP' || data.document?.salesDocumentTypeId === 2"
                    (valueChange)="changeOneTaxRateMode($event)"
                >
                    {{ 'SALES_DOCUMENT|Podatek VAT globalnie dla całego dokumentu' | translate }}
                </icc-radio>


                <icc-radio
                    id="vat-mode-position"
                    name="vat-mode"
                    [value]="'position'"
                    [checked]="mode === 'position'"
                    [disabled]="data.document?.isConfirmed || data.document?.isCanceled || data.document?.externalSource === 'ERP' || data.document?.salesDocumentTypeId === 2"
                    (valueChange)="changeOneTaxRateMode($event)"
                >
                    {{ 'SALES_DOCUMENT|Podatek VAT niezależnie dla pozycji' | translate }}
                </icc-radio>

            </div>
            <div
                *ngIf="data.document?.isOneTaxRateMode && data.document?.isCustomTaxRatesMode"
                class="flex-vertical w-100 mb-2"
            >
                <label iccLabel class="w-100">
                    {{ 'SALES_DOCUMENT|Stawka VAT:' | translate }}
                </label>
                <span class="w-100">

                    <icc-select
                        size="small"
                        [value]="taxRateId"
                        (valueChange)="changeTaxRate($event)"
                        [disabled]="data.document?.isConfirmed || data.document?.isCanceled || data.document?.externalSource === 'ERP' || data.document?.salesDocumentTypeId === 2"
                    >
                        <option *ngFor="let rate of taxRates" [value]="rate.id">
                            {{ rate.name }}
                        </option>
                    </icc-select>

                </span>
            </div>

            <div  class="flex-vertical w-100 mb-2">
                <label iccLabel class="w-100">
                    {{ 'SALES_DOCUMENT|Kalkulacja VAT' | translate }}
                </label>
                <span class="w-100">

                    <icc-select
                        size="small"
                        [value]="data.document?.taxRateCalculationMethod"
                        (valueChange)="changeVatCalculationMode($event)"
                        [disabled]="data.document?.isConfirmed || data.document?.isCanceled || data.document?.salesDocumentTypeId === 2"
                    >
                        <option value="netSummary" translate>SALES_DOCUMENT|od netto, VAT w podsumowaniu</option>
                        <option value="netPosition" translate>SALES_DOCUMENT|od netto, VAT do wartości pozycji</option>
                        <option value="grossSummary" translate>SALES_DOCUMENT|od brutto, VAT w podsumowaniu</option>
                    </icc-select>

                </span>
            </div>

        </div>
    </div>
    <div class="dialog-footer">

        <div class="flex-horizontal w-100">

            <div class="flex-horizontal right">

                <button
                    iccButton
                    (click)="close()"
                    appearance="primary"
                >
                    {{ 'INTERFACE|Zamknij' | translate}}
                </button>

            </div>

        </div>
    </div>

</div>
<div
    class="curtain"
    (click)="close()"
></div>
